import { render } from "./DepositedNftsPanel.vue?vue&type=template&id=2a1afef6&scoped=true"
import script from "./DepositedNftsPanel.vue?vue&type=script&lang=js"
export * from "./DepositedNftsPanel.vue?vue&type=script&lang=js"

import "@/Common/Styles/poolPanels.scss?vue&type=style&index=0&id=2a1afef6&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/THEOS-interfaces/THEOS-interfaces/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2a1afef6"]])

export default __exports__